import { AnyObject, BaseQuery, CollectionFilter, pregnancyStageFilterFields } from '@hb/shared'
import {
  collection,
  CollectionReference,
  Firestore,
  limit,
  orderBy,
  Query,
  query,
  where,
} from 'firebase/firestore'

const listFilterFields = Object.keys(pregnancyStageFilterFields)

// most targeted filters first
const optimizeFiltersAndSort = <T extends AnyObject>(
  filters: CollectionFilter<T>[] | undefined,
) => {
  if (!filters)
    return { equalityFilters: [], otherFilters: [], archivedFilter: null, listFilters: [] }
  const { equalityFilters, otherFilters, archivedFilter, listFilters } = filters.reduce(
    (acc, filter) => {
      const [fieldPath, opStr] = filter
      if (fieldPath === 'archived') {
        acc.archivedFilter = filter
        return acc
      }
      if (listFilterFields.includes(fieldPath)) {
        acc.listFilters.push(filter)
        return acc
      }
      if (opStr === '==') {
        acc.equalityFilters.push(filter)
      } else {
        acc.otherFilters.push(filter)
      }
      return acc
    },
    {
      archivedFilter: null as CollectionFilter<T> | null,
      equalityFilters: [] as CollectionFilter<T>[],
      otherFilters: [] as CollectionFilter<T>[],
      listFilters: [] as CollectionFilter<T>[],
    },
  )
  return { equalityFilters, otherFilters, archivedFilter, listFilters }
}

export const toFirestoreQuery = <T extends AnyObject>(
  db: Firestore,
  baseQuery: BaseQuery<T>,
): Query<T> => {
  const { filters, sort, collection: collectionPath, limit: limitTo } = baseQuery
  const collectionRef = collection(db, collectionPath) as CollectionReference<T>
  let q = query(collectionRef)
  // if (filters) {
  //   filters.forEach(([fieldPath, opStr, value]) => {
  //     q = query(q, where(fieldPath, opStr, value))
  //   })
  // }
  const { equalityFilters, otherFilters, archivedFilter, listFilters } =
    optimizeFiltersAndSort(filters)
  if (archivedFilter) {
    q = query(q, where(...archivedFilter))
  }
  listFilters.forEach(filter => {
    q = query(q, where(...filter))
  })
  if (sort) {
    sort.forEach(({ field, order }) => {
      q = query(q, orderBy(field, order))
    })
  }
  otherFilters.forEach(filter => {
    q = query(q, where(...filter))
  })
  equalityFilters.forEach(filter => {
    q = query(q, where(...filter))
  })

  if (limitTo) {
    q = query(q, limit(limitTo))
  }

  return q
}
